import directive from './directives';

const importDirective = Vue => {
  Vue.directive('ClickOutside', directive.ClickOutside);
  Vue.directive('p', directive.permissions);

  /**
   * 加载更多的指令
   * 示例：
   * <div class="dialog-body" v-loadmore="handleLoadMore">
   */
  Vue.directive('loadmore', {
    bind(el, binding) {
      el.addEventListener('scroll', function() {
        if (this.scrollHeight - this.scrollTop <= this.clientHeight) {
          binding.value();
        }
      });
    },
  });

  Vue.directive('draggable', directive.draggable);

  /**
   * 权限管理
   * 1、v-auth="['value1','value2']" => 匹配value1或value2其中一个就OK
   * 2、v-auth.and="['value1','value2']" =>同时匹配value1和value2才OK
   * 2、v-auth.ban="['value1','value2']" =>同时不匹配value1和value2才OK
   */
  Vue.directive('auth', directive.permissions);
};

export default importDirective;
